import { render, staticRenderFns } from "./SeatingReviewReport.vue?vue&type=template&id=30af5236&scoped=true"
import script from "./SeatingReviewReport.vue?vue&type=script&lang=js"
export * from "./SeatingReviewReport.vue?vue&type=script&lang=js"
import style0 from "./SeatingReviewReport.vue?vue&type=style&index=0&id=30af5236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30af5236",
  null
  
)

export default component.exports